import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import PaperDraggable from "../../../../../../components/PaperDraggable"
import groupBy from "../../../../../../helpers/groupBy"
import { useQuery } from "react-query"
import axiosClient from "../../../../../../lib/axios"
import { IDataDetalheExpItem, IDataDetalheExpedicao } from "../../../../../../types/api/estoque/detalhar-expedicao"
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery"
import EditIcon from '@mui/icons-material/Edit';
import { useState } from "react"
import DialogEditItem from "./DialgoEditItem"

export default function DialogEditExpedicao({
    open,
    handleClose
}: DialogEditExpedicaoProps) {

    const [openEditItem, setOpenEditItem] = useState<IDataDetalheExpItem | null>(null)

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ['dialog-detalhar-expedicoes'],
        queryFn: () => axiosClient.get("/estoque/detalhar-expedicao/" + open),
        keepPreviousData: false,
        refetchOnWindowFocus: true,
        cacheTime: 0
    });
    const detalheExp: IDataDetalheExpedicao = data?.data;
    //

    //valores importantes
    const itemsAgrupados = detalheExp ? groupBy(detalheExp.itens.sort((a, b) => a.produto.departamento.localeCompare(b.produto.departamento)), (i) => i.produto.departamento) : {};
    //

    //funções manipuladoras
    const handleTratarLotes = (lotes: Array<{ lote: string, quantidade: number }>) => {
        return lotes.map((lote) => {
            const qtd = lote.quantidade === 0 ? "-" : lote.quantidade;
            return <Typography variant="subtitle2">{`${lote.lote} | Qtd: ${qtd}`}</Typography>;
        });
    }
    //


    return (
        <>
            <Dialog
                open={Boolean(open)}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Editar expedição
                </DialogTitle>

                <DialogContent>
                    {
                        isLoading &&
                        <LoadingApiQuery />
                    }

                    {
                        !isLoading &&
                        <Grid container spacing={2} my={1}>
                            <Grid size={{xs: 12, md: 5}}>
                                <Typography variant="caption">Destinatário</Typography>
                                <Typography variant="h6">{detalheExp.destinatario}</Typography>
                            </Grid>

                            <Grid size={{xs: 12, md: 4}}>
                                <Typography variant="caption">Separador</Typography>
                                <Typography variant="h6">{detalheExp.nome_separador}</Typography>
                            </Grid>

                            <Grid size={{xs: 12, md: 3}}>
                                <Typography variant="caption">Data de criação</Typography>
                                <Typography variant="h6">{detalheExp.criado_em}</Typography>
                                <Typography variant="caption">por {detalheExp.criado_por}</Typography>
                            </Grid>

                            <Grid size={{xs: 12}}>
                                {
                                    Object.keys(itemsAgrupados).map((key) => {
                                        const items: IDataDetalheExpItem[] = itemsAgrupados[key].sort((a: IDataDetalheExpItem, b: IDataDetalheExpItem) => a.produto.nome.localeCompare(b.produto.nome));

                                        return (
                                            <Box mt={2}>
                                                <Typography fontWeight="bold" variant="body1">{key}</Typography>
                                                <TableContainer>
                                                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell width={320}>Produto</TableCell>
                                                                <TableCell width={110} align="right">Disponível</TableCell>
                                                                <TableCell align="right">Separar</TableCell>
                                                                <TableCell align="right">Encomenda</TableCell>
                                                                <TableCell align="right">Lote</TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                items.map((i, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={index}
                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                        >
                                                                            <TableCell>
                                                                                <Typography>{i.produto.nome}</Typography>
                                                                                <Typography variant="caption">Cód: {i.produto.codigo} / Setor: {i.produto.setor}</Typography>
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                {i.produto.estoque_atual}
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                {i.produto.qtd_separar}
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                {i.produto.encomenda_solicitada ? i.produto.encomenda_solicitada : '-'}
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                {i.produto.exige_lote && i.produto.lotes_selecionados?.length
                                                                                    ? handleTratarLotes(i.produto.lotes_selecionados)
                                                                                    : '-'}
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                <IconButton size="medium" onClick={() => setOpenEditItem(i)}>
                                                                                    <EditIcon fontSize="inherit" />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    }
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                openEditItem &&
                <DialogEditItem
                    open={openEditItem}
                    handleClose={() => setOpenEditItem(null)}
                />
            }
        </>
    )
}

interface DialogEditExpedicaoProps {
    open: number,
    handleClose: () => void
}

//